import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ExtensionService, ExtensionSettingsOutput } from 'core/http/project/extension/extension.service';
import { ownedError } from 'core/utils/owned-error';
import { Observable } from 'rxjs';

@Injectable()
export class ExtensionSettingsResolver {
  constructor(private extensionService: ExtensionService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<ExtensionSettingsOutput> {
    const extensionId = route.params.extensionId;

    if (!extensionId) {
      throw ownedError(new Error('Extension id is missing'));
    }

    return this.extensionService.getExtensionSettings(extensionId);
  }
}
